const PRODUCTION_API_URL = "https://api.adland.space";
const DEVELOPMENT_API_URL = "http://localhost:3069";

/**
 * Resolve the adland API base URL.
 *
 * Exported separately from `adlandApiUrl` so the resolution rules are testable
 * without mutating `process.env`.
 */
export function resolveAdlandApiUrl(
  override: string | undefined,
  nodeEnv: string | undefined,
): string {
  if (override) return override.replace(/\/$/, "");
  return nodeEnv === "development" ? DEVELOPMENT_API_URL : PRODUCTION_API_URL;
}

/**
 * Read the overrides, in a form a bundler can actually see.
 *
 * `process.env.NEXT_PUBLIC_*` is replaced with a literal at build time, but
 * only where it appears as that exact member expression. This used to capture
 * `process.env` into a variable first and read the key off it, which no bundler
 * can statically analyse — so the override was always `undefined` in the
 * browser and every browser build silently talked to adland's production API,
 * whatever the host had configured.
 *
 * The `typeof` guard still matters for the CDN bundle, where nothing performs
 * the replacement and `process` genuinely does not exist. It returns before any
 * property access, so reading it there is never attempted.
 */
function readEnv(): { override?: string; nodeEnv?: string } {
  if (typeof process === "undefined" || !process.env) return {};
  return {
    override: process.env.NEXT_PUBLIC_ADLAND_API_URL,
    nodeEnv: process.env.NODE_ENV,
  };
}

const { override, nodeEnv } = readEnv();

export const adlandApiUrl = resolveAdlandApiUrl(override, nodeEnv);

export const debug = true;
